(function(){'use strict';
var CONFIG={debounceMs:220,minChars:2,maxResults:8,apiBase:'/search/suggest.json',cacheTtl:60000,
trendingSearches:[
  {label:'Internal Doors',url:'/collections/internal-doors'},
  {label:'Fire Doors',url:'/collections/fire-doors'},
  {label:'Bifold Doors',url:'/collections/bifold-doors'},
  {label:'Door Handles',url:'/collections/door-handles-levers'},
  {label:'External Doors',url:'/collections/external-doors'},
  {label:'Sliding Doors',url:'/collections/sliding-doors'},
  {label:'Door Hinges',url:'/collections/door-hinges'}
]};
var cache={},activeIndex=-1,currentQuery='',debounceTimer=null,isOpen=false;
var searchForm,searchInput,searchDropdown,searchBackdrop,categorySelect,userHasInteracted=false;

function formatPrice(price){if(!price)return'';var num=parseFloat(price);return isNaN(num)?'':'\xA3'+num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,'$1,')}

function highlight(text,query){if(!query||!text)return text||'';var escaped=query.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');try{var regex=new RegExp('('+escaped+')','gi');return text.replace(regex,'<mark class="pc-search-highlight">$1</mark>')}catch(e){return text}}

function buildTrendingHtml(){
  var html='<div class="pc-search-trending">';
  html+='<div class="pc-search-trending-tags">';
  CONFIG.trendingSearches.forEach(function(t){
    html+='<a class="pc-search-tag" href="'+t.url+'">';
    html+='<svg viewBox="0 0 16 16" width="12" height="12" fill="currentColor"><path d="M6 2a4 4 0 100 8A4 4 0 006 2zM0 6a6 6 0 1110.89 3.477l4.817 4.816a1 1 0 01-1.414 1.414l-4.816-4.817A6 6 0 010 6z"/></svg>';
    html+=t.label+'</a>';
  });
  html+='</div></div>';
  return html;
}

function buildProductHtml(product,query,index){
  var imgSrc=product.featured_image&&product.featured_image.url||product.image&&(product.image.src||product.image)||'';
  imgSrc&&(imgSrc=imgSrc.replace(/(\.(jpg|png|webp|gif|jpeg))(\?|$)/i,'_80x80_crop_center$1$3'));
  var titleText=product.title||'',typeText=product.type||'',priceText=formatPrice(product.price);
  var comparePrice=parseFloat(product.compare_at_price_max||0),currentPrice=parseFloat(product.price||0);
  var oldPrice=comparePrice>currentPrice?formatPrice(product.compare_at_price_max):'';
  var inStock=product.available!==false,url=product.url||'/search?q='+encodeURIComponent(titleText);
  var html='<a class="pc-search-product" href="'+url+'" role="option" data-index="'+index+'">';
  html+='<div class="pc-search-product-img-wrap">';
  imgSrc?html+='<img src="'+imgSrc+'" alt="" loading="lazy" width="52" height="52">'
  :html+='<div class="pc-search-product-img-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="#ccc"><path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-1.1 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/></svg></div>';
  html+='</div><div class="pc-search-product-info">';
  html+='<div class="pc-search-product-title">'+highlight(titleText,query)+'</div>';
  html+='<div class="pc-search-product-meta">';
  typeText&&(html+='<span class="pc-search-product-type">'+typeText+'</span>');
  html+='<span class="pc-search-product-badge '+(inStock?'in-stock':'out-stock')+'">'+(inStock?'&#10003; In Stock':'Out of Stock')+'</span>';
  html+='</div></div>';
  html+='<div style="text-align:right;flex-shrink:0;min-width:70px">';
  html+='<div class="pc-search-product-price">'+priceText+'</div>';
  oldPrice&&(html+='<div class="pc-search-product-price-old">'+oldPrice+'</div>');
  html+='</div></a>';
  return html;
}

function showTrending(){
  var body=document.getElementById('pc-search-body');
  var status=document.getElementById('pc-search-status');
  if(body){
    status&&(status.textContent='Popular Categories');
    body.innerHTML=buildTrendingHtml();
    openDropdown();
    activeIndex=-1;
  }
}

function showLoading(){
  var body=document.getElementById('pc-search-body');
  body&&(body.innerHTML='<div class="pc-search-loading"><div class="pc-search-loading-dots"><span></span><span></span><span></span></div></div>');
}

function renderResults(products,query){
  var body=document.getElementById('pc-search-body');
  var status=document.getElementById('pc-search-status');
  if(!body)return;
  if(!products||products.length===0){
    status&&(status.textContent='No results');
    body.innerHTML='<div class="pc-search-no-results"><strong>No results for &quot;'+query+'&quot;</strong>Try different keywords or browse our categories</div>'+buildTrendingHtml();
    return;
  }
  status&&(status.textContent=products.length+' result'+(products.length!==1?'s':'')+' for "'+query+'"');
  var html='<div class="pc-search-results-title">Products</div><div class="pc-search-products">';
  products.slice(0,CONFIG.maxResults).forEach(function(p,i){html+=buildProductHtml(p,query,i)});
  html+='</div>';
  var cat=categorySelect?categorySelect.value:'';
  var viewUrl='/search?type=product&q='+encodeURIComponent(query)+(cat?'&product_type='+encodeURIComponent(cat):'');
  html+='<a class="pc-search-view-all" href="'+viewUrl+'">';
  html+='View all results for &quot;'+query+'&quot;';
  html+='<svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><path d="M1 8a.5.5 0 01.5-.5h11.793l-3.147-3.146a.5.5 0 01.708-.708l4 4a.5.5 0 010 .708l-4 4a.5.5 0 01-.708-.708L13.293 8.5H1.5A.5.5 0 011 8z"/></svg></a>';
  body.innerHTML=html;
  activeIndex=-1;
}

function fetchResults(query){
  var cat=categorySelect?categorySelect.value:'',cacheKey=query+'|'+cat,now=Date.now();
  if(cache[cacheKey]&&now-cache[cacheKey].ts<CONFIG.cacheTtl){renderResults(cache[cacheKey].data,query);return}
  showLoading();
  var url=CONFIG.apiBase+'?q='+encodeURIComponent(query)+'&resources[type]=product&resources[limit]='+CONFIG.maxResults;
  fetch(url).then(function(r){return r.json()}).then(function(data){
    var products=data.resources&&data.resources.results&&data.resources.results.products||[];
    cache[cacheKey]={data:products,ts:Date.now()};
    currentQuery===query&&renderResults(products,query);
  }).catch(function(){
    var body=document.getElementById('pc-search-body');
    body&&(body.innerHTML='<div class="pc-search-no-results"><strong>Search unavailable</strong><br>Please try again</div>');
  });
}

function moveSelection(dir){
  if(searchDropdown){
    var items=searchDropdown.querySelectorAll('.pc-search-product,.pc-search-tag,.pc-search-view-all');
    if(items.length){
      items[activeIndex]&&items[activeIndex].classList.remove('is-active');
      activeIndex=((activeIndex+dir)%items.length+items.length)%items.length;
      var active=items[activeIndex];
      active&&(active.classList.add('is-active'),active.scrollIntoView({block:'nearest'}));
    }
  }
}

function openDropdown(){
  if(searchDropdown){
    searchDropdown.style.display='block';
    searchDropdown.classList.add('is-visible');
    searchBackdrop&&searchBackdrop.classList.add('is-visible');
    isOpen=true;
  }
}

function closeDropdown(){
  if(searchDropdown){
    searchDropdown.style.display='none';
    searchDropdown.classList.remove('is-visible');
    searchBackdrop&&searchBackdrop.classList.remove('is-visible');
    isOpen=false;
    activeIndex=-1;
  }
}

function handleInput(){
  userHasInteracted=true;
  var query=searchInput?searchInput.value.trim():'';
  currentQuery=query;
  clearTimeout(debounceTimer);
  if(query.length===0){showTrending();return}
  if(query.length<CONFIG.minChars){closeDropdown();return}
  openDropdown();
  debounceTimer=setTimeout(function(){fetchResults(query)},CONFIG.debounceMs);
}

function init(){
  searchForm=document.querySelector('form.search-bar');
  searchInput=document.querySelector('.search-bar__input');
  categorySelect=document.querySelector('#search-product-type');
  if(!searchForm||!searchInput)return;
  var wrapper=searchForm.closest('.header__search-bar-wrapper')||searchForm.parentElement;
  wrapper.style.position='relative';
  searchBackdrop=document.createElement('div');
  searchBackdrop.id='pc-search-backdrop';
  document.body.appendChild(searchBackdrop);
  var dropEl=document.createElement('div');
  dropEl.innerHTML='<div id="pc-search-dropdown" role="listbox">'+
    '<div class="pc-search-header">'+
    '<span class="pc-search-header-left" id="pc-search-status">Popular Categories</span>'+
    '<button class="pc-search-close-btn" id="pc-search-close" type="button" aria-label="Close search">&times;</button>'+
    '</div>'+
    '<div id="pc-search-body"></div>'+
    '<div class="pc-search-footer">'+
    '<span class="pc-search-kbd-hint"><kbd>&uarr;</kbd><kbd>&darr;</kbd> navigate</span>'+
    '<span class="pc-search-kbd-hint"><kbd>Enter</kbd> select</span>'+
    '<span class="pc-search-kbd-hint"><kbd>Esc</kbd> close</span>'+
    '</div></div>';
  wrapper.appendChild(dropEl.firstChild);
  searchDropdown=document.getElementById('pc-search-dropdown');

  // Input event
  searchInput.addEventListener('input',handleInput);

  // Focus: only open if user has already interacted OR input has value
  searchInput.addEventListener('focus',function(){
    userHasInteracted=true;
    var val=searchInput.value.trim();
    if(val.length>=CONFIG.minChars){handleInput();}
    else{showTrending();}
  });

  // Keyboard navigation
  searchInput.addEventListener('keydown',function(e){
    if(e.key==='ArrowDown'){e.preventDefault();moveSelection(1);}
    else if(e.key==='ArrowUp'){e.preventDefault();moveSelection(-1);}
    else if(e.key==='Enter'&&isOpen){
      var active=searchDropdown.querySelector('.pc-search-product.is-active,.pc-search-view-all.is-active');
      if(active&&active.href){e.preventDefault();window.location.href=active.href;}
      closeDropdown();
    }
    else if(e.key==='Escape'){closeDropdown();searchInput.blur();}
  });

  // Category filter change
  categorySelect&&categorySelect.addEventListener('change',function(){
    if(searchInput.value.trim().length>=CONFIG.minChars)handleInput();
  });

  // Close button (mousedown AND click for reliability)
  var closeBtn=document.getElementById('pc-search-close');
  if(closeBtn){
    closeBtn.addEventListener('mousedown',function(e){e.preventDefault();closeDropdown();});
    closeBtn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();closeDropdown();});
  }

  // Click/mousedown outside closes dropdown
  document.addEventListener('mousedown',function(e){
    var closeBtnEl=document.getElementById('pc-search-close');
    if(closeBtnEl&&closeBtnEl.contains(e.target))return;
    if(searchDropdown&&!searchForm.contains(e.target)&&!searchDropdown.contains(e.target)){
      closeDropdown();
    }
  });

  // Backdrop click
  searchBackdrop&&searchBackdrop.addEventListener('click',closeDropdown);
}

document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
})();